import { createSelector } from 'reselect';

const getHoliday    =   (state)  => state.holiday.entities;
const getDate       =   (state, props) => props.date;

const getHolidayByDate = createSelector([getHoliday, getDate], (holiday, date) => {
    let allHolidays = holiday.allIds.map((holidayId) => holiday.byId[holidayId]);

    let month = parseInt(date.getMonth() + 1);
    if(month < 10) {
        month = `0${month}`;
    }

    let day = parseInt(date.getDate());
    if(day < 10) {
        day = `0${day}`;
    }

    let dateString = `${date.getFullYear()}-${month}-${day} 00:00:00`;

    let currentHolidays = allHolidays.filter((holidayItem, index) => holidayItem.date == dateString); //Get all holidays on a specific date
    let specialDays = currentHolidays.filter((h)=>h.special == 1); //Filter for 'special' days (e.g., valentinesday, studiedag) from currentHolidays
    let currentHoliday = specialDays.length == 0 ? currentHolidays.filter((h)=>h.special == 0)[0] : specialDays[0]; //If no special day, send all holidays otherwise only first since 'special' days only have a duration of 1 day.

    return currentHoliday ? currentHoliday : null;
});

export default getHolidayByDate;
